@if (config) {
<div class="pr-card">

  <!-- Header -->
  @if (config.title) {
  <div class="pr-card__header">
    @if (config.headerIcon) {
      <span class="pr-card__header-icon">
        <i class="pi {{ config.headerIcon }}"></i>
      </span>
    } @else {
      <span class="pr-card__dot"></span>
    }
    <h4 class="pr-card__title">{{ config.title }}</h4>
    <span class="pr-card__count">{{ config.items.length }} misiones</span>
  </div>
  }

  <!-- Grid de anillos -->
  <div class="pr-grid" [style.--cols]="cols">
    @for (item of config.items; track item.label) {

      <div class="pr-cell">
        <!-- Anillo SVG -->
        <div class="pr-ring" [style.filter]="'drop-shadow(' + ringGlow(item.pct) + ')'">
          <svg class="pr-ring__svg" viewBox="0 0 64 64">
            <!-- Pista (fondo) -->
            <circle class="pr-ring__track" cx="32" cy="32" [attr.r]="26" />
            <!-- Relleno animado -->
            <circle class="pr-ring__fill"
                    cx="32" cy="32"
                    [attr.r]="26"
                    [style.stroke]="ringColor(item.pct)"
                    [attr.stroke-dasharray]="circumference"
                    [attr.stroke-dashoffset]="dashOffset(item.pct)" />
          </svg>
          <!-- Texto central -->
          <span class="pr-ring__center" [style.color]="ringColor(item.pct)">
            {{ pctLabel(item.pct) }}
          </span>
        </div>

        <!-- Etiqueta -->
        <p class="pr-cell__label">{{ item.label }}</p>
        @if (item.sublabel) {
          <p class="pr-cell__sublabel">{{ item.sublabel }}</p>
        }
      </div>

    }
  </div>

  <!-- Leyenda semáforo -->
  <div class="pr-legend">
    <span class="pr-legend__item pr-legend__item--ok">
      <i class="pr-legend__dot"></i>≥ 100%
    </span>
    <span class="pr-legend__item pr-legend__item--warn">
      <i class="pr-legend__dot"></i>80 – 99%
    </span>
    <span class="pr-legend__item pr-legend__item--danger">
      <i class="pr-legend__dot"></i>&lt; 80%
    </span>
  </div>

</div>
}
